import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_OrganizationPermission } from '../ModuleFE_OrganizationPermission.js';
import { orgPermissionNameResolver } from '../utils.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_OrganizationPermission,
    modules: [ModuleFE_OrganizationPermission],
    mapper: item => [orgPermissionNameResolver(item._id)],
    placeholder: 'Choose a Organization Permission',
    caret: DropDown_DefaultCaret,
    renderer: item => _jsxs(_Fragment, { children: [" ", orgPermissionNameResolver(item._id), " "] })
};
export const DropDown_OrganizationPermissions = GenericDropDownV3.prepare(Props_DropDown);
//# sourceMappingURL=ui-components.js.map